<template>
  <div class="reader-image__placeholder">
    <div class="mb-2 flex justify-center" style="width: 50%">
      <img src="/assets/nami/stickers/love.png" />
    </div>
    <div class="reader-image__placeholder-progress">
      <div class="relative text-center" style="z-index: 1">0%</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PlaceholderPageGroup } from "~/src/reader/managers/pageGroup";

interface Props {
  page: PlaceholderPageGroup;
  containerDimensions?: {
    width: number;
    height: number;
  };
}

const { page, containerDimensions } = defineProps<Props>();

const aspect = computed(() => page.width / page.height);
const maxWidth = computed(() => {
  let width = window?.innerWidth < page.width ? "100vw" : `${page.width}px`;

  if (containerDimensions) {
    const maxHeight = Math.min(containerDimensions.height, page.height);
    const maxWAR = maxHeight * aspect.value;
    return Math.min(containerDimensions.width, page.width, maxWAR) + "px";
  }

  return width;
});
</script>

<style scoped lang="postcss">
.reader-image__placeholder {
  width: v-bind(maxWidth);
  height: calc(v-bind(maxWidth) / v-bind(aspect));

  @apply relative m-auto p-4
  bg-neutral-200 overflow-hidden border-2 border-neutral-300 rounded-md
  dark:bg-neutral-700 dark:border-neutral-600
  flex flex-col items-center justify-center;
}

@keyframes shimmer {
  0% {
    opacity: 1;
    border-width: 8px;
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    opacity: 0;
    border-width: 0;
    transform: translate(-50%, -50%) scale(1);
  }
}

.reader-image__placeholder-progress {
  z-index: 3;
  max-width: 400px;
  @apply relative w-full mt-1 bg-neutral-100 rounded-md overflow-hidden
  dark:bg-neutral-500;

  &:after {
    content: "";
    width: 0;
    @apply absolute left-0 top-0 h-full bg-nami-nami-blue;
  }
}
</style>
